import { differenceInWeeks, formatDistanceStrict, format } from "date-fns";

import { Dateable, TimeSpanFormatter } from "../types";

const formatTimeSpan: TimeSpanFormatter = (
  endDate: Dateable,
  startDate: Dateable,
  addSuffix = true,
) => {
  // if the difference is more than 1 week, we should show the full date
  const fullWeeks = Math.abs(differenceInWeeks(endDate, startDate));
  if (fullWeeks > 0) {
    return format(startDate, "LLL d, yyyy");
  }

  // else, use relative time
  return formatDistanceStrict(startDate, endDate, { addSuffix });
};

export default formatTimeSpan;
